module.exports = __webpack_public_path__ + "static/img/Stylus2.75af3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Stylus2.png
// module id = v6EQ
// module chunks = 0